import $ from 'jquery';
import { getState, modifyState } from '~src/state';
import { toggleEditorHomeMenu, showSpinner } from '~loader/loader-utils';
import { onErrorShowMessage } from '~src/errors';
import { router } from '~src/router';
import { saveEditorCanvas } from '~src/api';
import { createEmptyPage } from '~src/multipages';

const commonHandler = (event) => {
  event.preventDefault();
  event.stopPropagation();

  const project = getState('selected.tipo');

  const formatId = $(event.currentTarget).data('format-id');

  window.urlParams.set('formato', formatId);
  window.history.replaceState(
    {},
    '',
    `${window.location.href.split('?')[0]}?` + window.urlParams
  );

  $('[data-format-id]').removeClass('block-selected block-default');

  $(event.currentTarget).addClass('block-selected');

  const format = window.editorLoader.formats[
    project.objectId
  ].formats.items.find((format) => format.objectId === formatId);

  modifyState('selected.formato', format);
  modifyState(
    'selected.formatoDefault',
    format.editor_project_formats_default_pointer
  );
};

export const createEditorCanvas = async () => {
  const pages = [createEmptyPage()];

  modifyState('pages', pages);

  toggleEditorHomeMenu();
  showSpinner();

  try {
    const objectId = await saveEditorCanvas(true);
    window.editorLoader.canvasId = objectId;

    // to open the sidebar we cannot use querystring here
    // because when navigo redirects, the URL is not updated
    // in the browser and the querystring cannot be read
    // it returns null.
    modifyState('opensidebar', 'templates');
    router.navigate(`/canvas/${objectId}`);
  } catch (error) {
    console.error(error);
    onErrorShowMessage(true);
  }
};

export const formatClickHandler = async (event) => {
  commonHandler(event);
  await createEditorCanvas();
};
